module.exports = __webpack_public_path__ + "img/wall_street_logo.80825871.png";